import { DCPKeyValueDTO, DCPPreCheckoutStepDTO } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

export enum CustomerType {
  PRIVATE = 'B2C',
  BUSINESS = 'B2B',
}

export enum StepsType {
  DEALER_LOCATOR = 'DEALER_LOCATOR',
  FINANCIAL_CALCULATOR = 'FINCALC',
}

export enum VansType {
  NCOS_B_COMVANS = 'NCOS_B_COMVANS',
  NCOS_D_COMVANS = 'NCOS_D_COMVANS',
}

export enum LegalTypeGroups {
  B2BA = 'B2BA',
  B2BB = 'B2BB',
  B2C = 'B2C',
  NONE = 'NONE',
}

export interface IConfigValue {
  type: string;
  value: string;
}

export default class PreCheckoutStep implements DCPPreCheckoutStepDTO {
  type: string;
  config: DCPKeyValueDTO[] | undefined;

  constructor(data: DCPPreCheckoutStepDTO) {
    this.type = data.type as string;
    this.config = data.config;
  }

  static create(data: DCPPreCheckoutStepDTO) {
    return new PreCheckoutStep(data);
  }
}
